export default __webpack_public_path__ + "static/media/Computer.fdb68b72.mp4";